<div class="mobile-view-sort">
  <div class="auto-complete-parent">
    <app-autocomplete-serverside
      [dataCollection]="searchSourceCollection"
      [componentNameRef]="componentName"
      [functionName]="functionName"
      (messageEvent)="inventoryResult($event)"
      (optionSelect)='selectedListitem($event)'
      [searchoptionalParams]="searchoptionalParams"
      (callFocusOut)="autocompleteFO()"
      (callFocusIn)="autocompleteFI()"
      (pasteFunc)="searchPasteData($event)">
    </app-autocomplete-serverside>
  </div>
  @if (showOptions) {
    <div class='autoCompleteOptions'>
      @if (filteredSearchResult.length > 0) {
        <cdk-virtual-scroll-viewport #scrollViewport  (scroll)="fetchData($event)" [itemSize]="5"  [ngClass]="filteredSearchResult.length <= 5 ? 'exv-'+ filteredSearchResult.length : 'example-viewport'" [style.height]="filteredSearchResult.length <= 5 ? (filteredSearchResult.length * 40) + 'px' : '250px'">
          @for (item of filteredSearchResult; track item) {
            <mat-option id="{{item.Name}}"
              (click)="onSearchItemClick(item,true)" [value]="item.Name" class='option-list'>
              <div class="search-name-div">
                <span class="search-name">{{item.FullSearchText}}</span>
              </div>
            </mat-option>
          }
        </cdk-virtual-scroll-viewport>
      }
      @if (filteredSearchResult.length === 0) {
        <mat-option>
          <div>{{'common.noDataFound' | translate}}</div>
        </mat-option>
      }
    </div>
  }

  @if (showForm) {
    <div class="dynamicForm">
      <div>
        <h6>Inventory Details</h6>
        <div class="inner-card1">
          <div class="inner-data">
            <span class="head">Inventory Name</span>
            <span class="data">{{ingredientDetail.Name}}</span>
          </div>
        </div>
        @for (data of ingredientDetail.Units; track data) {
          <div class="ingredient-details">
            <div class="inner-card1">
              <div class="inner-data">
                <span class="head">{{data.UnitTypeName}}</span>
                <span class="data">{{data.UnitName}}</span>
              </div>
            </div>
            <div class="inner-card2">
              <div class="inner-data">
                <span class="head">Conversion</span>
                <span class="data">{{data.Conversion | decimalFormatter}}</span>
              </div>
            </div>
          </div>
        }
      </div>
      <h6>Barcode Details</h6>
      @if (config.length) {
        <div>
          <app-dynamic-form [config]="config" #form="dynamicForm" (submit)="confirm($event)"></app-dynamic-form>
        </div>
      }
    </div>
  }
</div>